import { colors } from "./colors";

export function setLightTheme() {
  for (const color of colors) {
    document.documentElement.style.setProperty(
      `--lg-${color}`,
      `var(--sja-${color})`,
    );
  }

  // overrides
  document.documentElement.style.setProperty("--lg-black", "var(--dk-black)");

  document.documentElement.style.setProperty(
    "--lg-light-black",
    "var(--dk-light-black)",
  );
  document.documentElement.style.setProperty(
    "--lg-darkest-gray",
    " var(--dk-darkest-gray)",
  );
  document.documentElement.style.setProperty(
    "--lg-darker-gray",
    "var(--dk-darker-gray)",
  );
  document.documentElement.style.setProperty(
    "--lg-dark-gray",
    "var(--dk-dark-gray)",
  );
  document.documentElement.style.setProperty(
    "--lg-light-gray",
    "var(--dk-light-gray)",
  );
  document.documentElement.style.setProperty(
    "--lg-lighter-gray",
    "var(--dk-lighter-gray)",
  );

  document.documentElement.style.setProperty(
    "--lg-lightest-gray",
    "var(--dk-lightest-gray)",
  );
  document.documentElement.style.setProperty(
    "--lg-darker-white",
    "var(--dk-darker-white)",
  );
  document.documentElement.style.setProperty("--lg-white", "var(--dk-white)");
}

export function setDarkTheme() {
  for (const color of colors) {
    document.documentElement.style.setProperty(
      `--lg-${color}`,
      `var(--dk-${color})`,
    );
  }

  // overrides
  document.documentElement.style.setProperty("--lg-black", "var(--dk-white)");

  document.documentElement.style.setProperty(
    "--lg-light-black",
    "var(--dk-darker-white)",
  );
  document.documentElement.style.setProperty(
    "--lg-darkest-gray",
    "var(--dk-lightest-gray)",
  );
  document.documentElement.style.setProperty(
    "--lg-darker-gray",
    "var(--dk-lighter-gray)",
  );
  document.documentElement.style.setProperty(
    "--lg-dark-gray",
    "var(--dk-light-gray)",
  );
  document.documentElement.style.setProperty(
    "--lg-light-gray",
    "var(--dk-dark-gray)",
  );
  document.documentElement.style.setProperty(
    "--lg-lighter-gray",
    "var(--dk-darker-gray)",
  );

  document.documentElement.style.setProperty(
    "--lg-lightest-gray",
    "var(--dk-darkest-gray)",
  );
  document.documentElement.style.setProperty(
    "--lg-darker-white",
    "var(--dk-black)",
  );
  document.documentElement.style.setProperty(
    "--lg-white",
    "var(--dk-light-black)",
  );
}
